import React from 'react';
import {
  QuickRepliesMessage,
  BotAgentMessage,
  CollectionName,
} from '@tomis-tech/types';

import { useSession, useTyping } from '../context';
import { sendNewCustomerMessage } from '../services/sendNewCustomerMessage';
import { logError } from '.././sentry-iframe';

export interface QuickRepliesProps {
  data: QuickRepliesMessage;
  message: BotAgentMessage;
}

const QuickReplies: React.FC<QuickRepliesProps> = ({ data, message }) => {
  const { conversation } = useSession();
  const { setIsTyping } = useTyping();
  const isVisible = message.hideQuickReplies !== true;

  async function sendMessage(text: string, hideOnSelection: boolean) {
    if (hideOnSelection) {
      conversation.ref
        .collection(CollectionName.Messages)
        .doc(message.id)
        .update({ hideQuickReplies: true })
        .catch(logError);
    }

    // Only create a typing gif when bot will respond (i.e. NOT web chat)
    if (!conversation.value.useHumanAgent) {
      setIsTyping(true);
    }

    await sendNewCustomerMessage({
      text,
      conversationId: conversation.ref.id,
    });

    setIsTyping(false);
  }

  if (!isVisible || !data) return null;
  let hideOnSelection = false;
  let options: string[] = [];

  /** try/catch to ensure custom payload is formatted correctly by chatbot admins */
  try {
    hideOnSelection = data.hideOnSelection.stringValue === 'true';
    options = data.quickReplies.listValue.values.map(
      value => value.stringValue
    );
  } catch (error) {
    console.error(
      'ERROR: cannot display Quick Replies. Please double-check the format of custom payload in Dialogflow!.....',
      error.message
    );
    hideOnSelection = true;
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-evenly',
          alignItems: 'center',
        }}
      >
        {options.map(option => (
          <div
            key={option}
            css={{
              padding: '5px 15px',
              margin: '2px',
              borderRadius: '25px',
              backgroundColor: 'white',
              border: '1px solid rgb(0,112,255)',
              color: 'rgb(0,112,255)',
              fontSize: 14,
              '&:hover': {
                backgroundColor: 'rgb(0,112,255)',
                color: 'white',
                cursor: 'pointer',
              },
            }}
            onClick={e => {
              e.preventDefault();
              sendMessage(option, hideOnSelection);
            }}
          >
            {option}
          </div>
        ))}
      </div>
    </>
  );
};

export default QuickReplies;
